const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export interface SiteSettings {
  maintenance_mode: boolean;
  updated_at?: string;
}

const DEFAULT_SETTINGS: SiteSettings = { maintenance_mode: false };

export async function fetchSiteSettings(): Promise<SiteSettings> {
  try {
    const res = await fetch(`${API_BASE}/api/site-settings?t=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!res.ok) return DEFAULT_SETTINGS;
    const json = await res.json();
    return {
      maintenance_mode: !!json.maintenance_mode,
      updated_at: json.updated_at,
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
}
